import type { ComponentType, SVGProps } from 'react';
import {
    FacebookIcon,
    InstagramIcon,
    ThreadsIcon,
    TikTokIcon,
    TwitterIcon,
    YoutubeIcon,
} from '@/shared-ui/icons/social-media';

export const SOCIAL_MEDIA_PLATFORM_IDS = ['instagram', 'tiktok', 'youtube', 'facebook', 'twitter', 'threads'] as const;

export type SocialMediaPlatformId = (typeof SOCIAL_MEDIA_PLATFORM_IDS)[number];

export const SOCIAL_MEDIA_PLATFORM_LABELS: Record<SocialMediaPlatformId, string> = {
    instagram: 'Instagram',
    tiktok: 'TikTok',
    youtube: 'YouTube',
    facebook: 'Facebook',
    twitter: 'Twitter',
    threads: 'Threads',
};

export const SOCIAL_MEDIA_PLATFORM_ICONS: Record<SocialMediaPlatformId, ComponentType<SVGProps<SVGSVGElement>>> = {
    instagram: InstagramIcon,
    tiktok: TikTokIcon,
    youtube: YoutubeIcon,
    facebook: FacebookIcon,
    twitter: TwitterIcon,
    threads: ThreadsIcon,
};

export function isSocialMediaPlatformId(value: string): value is SocialMediaPlatformId {
    return (SOCIAL_MEDIA_PLATFORM_IDS as readonly string[]).includes(value);
}
